import {
  CrmBoardTemplateId,
  getCrmBoardTemplate,
} from "../constants/crm-board-templates";
import { boardApiService } from "../services/api";

export async function applyCrmBoardTemplate(
  companyId: string,
  boardId: string,
  templateId: CrmBoardTemplateId,
  locale?: string
): Promise<void> {
  const template = getCrmBoardTemplate(templateId);
  const listConfigs = template.buildLists(locale);

  if (templateId === "blank" || listConfigs.length === 0) {
    return;
  }

  const { lists: existingLists } = await boardApiService.getLists(
    companyId,
    boardId
  );

  for (const existingList of existingLists) {
    await boardApiService.deleteList(companyId, boardId, existingList.id);
  }

  for (const listConfig of listConfigs) {
    const { list } = await boardApiService.postList(
      companyId,
      listConfig.name,
      boardId
    );

    if (!list?.id) {
      throw new Error(`No se pudo crear la columna "${listConfig.name}".`);
    }

    await boardApiService.putList(companyId, boardId, list.id, {
      percentage: listConfig.percentage,
      addToProbability: listConfig.addToProbability,
    });
  }
}
